import { MailSendConfig } from '@agent-ds/shared/components/mail-send/config';
import { StudentDetailConfig } from '@agent-ds/shared/components/mail-send/configs/student-detail-config';
import { StudentSendConfig } from '@agent-ds/shared/components/mail-send/configs/student-send-config';
import { Contract, CustomerList, CustomerProgressList, DashboardType, ExpectedCompanyResponseDto, ProgressItemResponse, ProgressAgentType, ResponseStatus, SituationMemo, Student, StudentSituationMemo, Yomi3ProbabilityCalcResult, YomiType } from '@agent-ds/shared/interfaces';
import { AmountRows, SalesAmount, SalesAmountForUser, SalesSummary, SalesSummaryForUser, SalesSummaryRow, TeamMonthlySalesOverviews, MonthlySalesOverview } from '@agent-ds/shared/interfaces/sale';
import {
  AuthService,
  CompanyApiService,
  CustomerApiService,
  CustomerExpectedCompanyYomiService,
  DialogService,
  DynamicFieldService,
  ExpectedCompanyTarget,
  ExportApiService,
  LayoutGlobalManagementHeaderVisibilityService,
  MasterApiService,
  SalesApiService,
  StudentApiService,
  UserApiService,
  Yomi3Target,
  YomiFormatedStudentSituationMemo,
  YomiFormatedStudentSituationMemoData,
} from '@agent-ds/shared/services';
import { cleanObject } from '@agent-ds/shared/util/util';
import { PROGRESS_STATUSES } from '@agent-ds/shared/constants';
import { UserTeamInjectorProvider } from '@agent-ds/shared/services/api/providers/user-team-injector.provider';
import { StudentTabs } from '@agent-ds/student/pages/student-detail-page/tabs/student-tabs';
import { Location } from '@angular/common';
import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, Observable, of, Subscription } from 'rxjs';

import { PageScrollTableComponent } from '../../page-scroll-table/page-scroll-table.component';
import {
  CustomerFilterCondition,
  CustomerFilterDefinition,
  CustomerFilterOption,
} from '../components/customer-filter-button-and-dialog/customer-filter-button-and-dialog.component';

import { DynamicField } from '@agent-ds/shared/models';
import * as moment from 'moment';
import * as _ from 'underscore';
import { GyosekiManagementCustomerProgressSkInfoDialogComponent } from '../components/gyoseki-management-customer-progress-sk-info-dialog/gyoseki-management-customer-progress-sk-info-dialog.component';
import { openEnterpriseDetail, openEnterpriseDetailWithId, openStudentDetail, openStudentDetailMemo, openStudentMailSend } from '@agent-ds/shared/util/student-detail-actions';



@Component({
  selector: 'ag-global-ra-gyoseki-management-header',
  templateUrl: './global-ra-gyoseki-management-header.component.html',
  styleUrls: ['./global-ra-gyoseki-management-header.component.scss'],
})
export class GlobalRaGyosekiManagementHeaderComponent implements OnInit, OnDestroy {
  @ViewChild(PageScrollTableComponent, { static: false }) table: PageScrollTableComponent;
  @ViewChild('customer', { static: false }) customerTemplate: TemplateRef<any>;
  @ViewChild('school', { static: false }) schoolTemplate: TemplateRef<any>;
  @ViewChild('graduateYear', { static: false }) graduateYearTemplate: TemplateRef<any>;
  @ViewChild('universityLevel', { static: false }) universityLevelTemplate: TemplateRef<any>;
  @ViewChild('sf', { static: false }) sfTemplate: TemplateRef<any>;
  @ViewChild('actions', { static: false }) actionsTemplate: TemplateRef<any>;
  @ViewChild('textfield', { static: false }) textfieldTemplate: TemplateRef<any>;

  @Output() readonly itemChecked = new EventEmitter<{ item?: any; checked: boolean }>();

  yomi3PassedDropdownData = [];
  yomi3InclinationDropdownData = [];
  yomi3ScheduleDropdownData = [];
  yomiDropdownData = [];
  expectedContractWeekDropdownData = [];

  weekTarget4w = {
    w1: {
      カタ: 1,
      FCST: 1,
      'FCST+': 8,
    },
    w2: {
      カタ: 1,
      FCST: 2,
      'FCST+': 8,
    },
    w3: {
      カタ: 2,
      FCST: 3,
      'FCST+': 6,
    },
    w4: {
      カタ: 4,
      FCST: 4,
      'FCST+': 4,
    },
  };

  readonly weekTarget5w = {
    w1: {
      カタ: 0,
      FCST: 1,
      'FCST+': 6,
    },
    w2: {
      カタ: 1,
      FCST: 2,
      'FCST+': 8,
    },
    w3: {
      カタ: 2,
      FCST: 2,
      'FCST+': 8,
    },
    w4: {
      カタ: 3,
      FCST: 3,
      'FCST+': 6,
    },
    w5: {
      カタ: 4,
      FCST: 4,
      'FCST+': 4,
    },
  };

  readonly defaultSalesForUserModel = {
    ca: {
      sn: 0,
      snAg: 0,
      snPlus: 0,
      sk: 0,
      skAg: 0,
      skPlus: 0,
      cancelSn: 0,
      cancelSnAg: 0,
      cancelSnPlus: 0,
      cancel: 0,
      cancelAg: 0,
      cancelPlus: 0,
    },
    rapa: {
      sn: 0,
      snAg: 0,
      snPlus: 0,
      sk: 0,
      skAg: 0,
      skPlus: 0,
      cancelSn: 0,
      cancelSnAg: 0,
      cancelSnPlus: 0,
      cancel: 0,
      cancelAg: 0,
      cancelPlus: 0,
    }
  };
  readonly defaultSalesForTeamModel: SalesAmount = {
    ca: {
      users: [],
      total: {
        sn: 0,
        snAg: 0,
        snPlus: 0,
        sk: 0,
        skAg: 0,
        skPlus: 0,
        cancelSn: 0,
        cancelSnAg: 0,
        cancelSnPlus: 0,
        cancel: 0,
        cancelAg: 0,
        cancelPlus: 0,
      }
    },
    rapa: {
      users: [],
      total: {
        sn: 0,
        snAg: 0,
        snPlus: 0,
        sk: 0,
        skAg: 0,
        skPlus: 0,
        cancelSn: 0,
        cancelSnAg: 0,
        cancelSnPlus: 0,
        cancel: 0,
        cancelAg: 0,
        cancelPlus: 0,
      }
    }
  };
  readonly defaultSalesSummaryForUserModel = {
    ca: {},
    rapa: {}
  };
  readonly defaultSalesSummaryForTeamModel: SalesSummary = {
    ca: {
      users: {},
      total: {}
    },
    rapa: {
      users: {},
      total: {}
    }
  };
  readonly MGR_DISPLAY_DASHBOARD_TYPES = [DashboardType.RA_Manager];

  enterprises = [];
  studentTabs = {
    OVERVIEW: 0,
    DETAIL: 1,
    ACADEMIC: 2,
    PREFERENCES: 3,
    PROGRESS: 4,
    CONTACTS: 5,
    MESSAGE: 6,
    MEMO: 7,
    FILES: 8,
    SEMINARS: 9,
    MATCHES: 10,
  };

  detailConfig = new StudentDetailConfig();
  sendConfig = new StudentSendConfig();

  tabs = StudentTabs;
  initialized = false;
  userNameSortStatus = 'asc';
  yomiSortStatus = 'asc';
  activeSortStatus = 'asc';
  progressSortStatus = 'asc';
  sfSortStatus = 'asc';
  yomi3PassedSortStatus = 'asc';
  yomi3InclinationSortStatus = 'asc';
  yomi3ScheduleSortStatus = 'asc';
  graduateYearSortStatus = 'asc';
  pickUpMemoRegisterSortStatus = 'asc';

  get checkedItems(): Student[] {
    return this.table ? this.table.checkedItems : [];
  }

  get allChecked(): boolean {
    return this.table.allChecked;
  }

  get totalSize(): number {
    return this.table.totalSize;
  }

  init = false;
  isHeaderOpen = false;
  isHeaderOpenSubscriber?: Subscription = null;
  loadingCustomer = false;
  loginSubscription?: Subscription = null;
  studentsRefreshSubscription?: Subscription = null;
  customerApiRefreshSubscription?: Subscription = null;
  dynamicFieldSubscription?: Subscription = null;

  customers: Student[] = [];
  customerProgresses: ProgressItemResponse[] = [];
  customerTotal = 0;
  currentPage = 1;
  readonly pageSize = 50;
  totalFilteredCount = 0;

  // Original Customer Expected Company List Collection
  customersExpectedCompanyListMapping: Record<number, ExpectedCompanyResponseDto[]> = {};
  // Formatted list of expected companies for UI display
  customersExpectedCompanyUIList: Record<string, {label: string, value: number}[]> = {};
  // Expected Company 1 Mappings
  customersExpectedCompanyProgressIdMapping: Record<number, number> = {};
  customersExpectedCompanyMapping: Record<number, ExpectedCompanyResponseDto> = {};
  // Expected Company 2 Mappings
  customersExpectedCompany2ProgressIdMapping: Record<number, number> = {};
  customersExpectedCompany2Mapping: Record<number, ExpectedCompanyResponseDto> = {};

  // RA業績管理表 > 進捗毎のRAヨミ3軸の計算結果
  customerProgressesRaYomi3ProbabilityResultMapping: Record<number, Yomi3ProbabilityCalcResult> = {};

  // Exposing the ExpectedCompanyTarget enum to HTML side
  ExpectedCompanyTarget = ExpectedCompanyTarget;
  // Exposing the Yomi3Target enum to HTML side
  Yomi3Target = Yomi3Target;

  pickUpMemo: Record<number, YomiFormatedStudentSituationMemo> = {};
  salesForUserModel: SalesAmountForUser = this.defaultSalesForUserModel;
  salesSummaryForUserModel: SalesSummaryForUser = this.defaultSalesSummaryForUserModel;
  salesForTeamModel: SalesAmount = this.defaultSalesForTeamModel;
  salesSummaryForTeamModel: SalesSummary = this.defaultSalesSummaryForTeamModel;

  // Contracted Month Configurations
  // How many month ahead can be selected
  expectedContractMonthConfigAhead = 3;
  // How many month behind can be selected
  expectedContractMonthConfigBehind = 12;
  // The properties that stores and updates the input's value, min, and max.
  expectedContractMonthMinOption: string;
  expectedContractMonthMaxOption: string;
  selectedExpectedContractMonthValue: string;

  expectedContractWeeklyValue: string;
  expectedContractWeeklyInputWidth: number;
  userHasManagementRole = false;
  selectedManagementTeamId?: number = null;
  customerFilterConditions: CustomerFilterCondition[] = [];
  private userNameMap: Record<number, string> = {};

  constructor(
    protected router: Router,
    protected activeRoute: ActivatedRoute,
    protected location: Location,
    protected exportService: ExportApiService,
    private dynamicService: DynamicFieldService,
    private dialog: DialogService,
    private authService: AuthService,
    private customerApiService: CustomerApiService,
    private companyApiService: CompanyApiService,
    public readonly masterService: MasterApiService,
    public readonly userService: UserApiService,
    public readonly userTeamInjector: UserTeamInjectorProvider,
    public readonly fb: FormBuilder,
    private managementTableVisibility: LayoutGlobalManagementHeaderVisibilityService,
    private expectedCompanyYomiService: CustomerExpectedCompanyYomiService,
    private studentService: StudentApiService,
  ) {
    // Create the initial data of the contracted month date filter.
    const now = moment();
    this.selectedExpectedContractMonthValue = moment().format('YYYY-MM');
    this.expectedContractMonthMinOption = now
      .clone()
      .subtract(this.expectedContractMonthConfigBehind, 'months')
      .format('YYYY-MM');
    this.expectedContractMonthMaxOption = now
      .clone()
      .add(this.expectedContractMonthConfigAhead, 'months')
      .format('YYYY-MM');
  }

  ngOnInit() {
    this.loginSubscription = this.authService.isLogined().subscribe((logined) => {
      if (logined) {
        this.userHasManagementRole = this.MGR_DISPLAY_DASHBOARD_TYPES.includes(
          this.authService.loginUser.dashboardType
        );
        this.selectedManagementTeamId = this.userHasManagementRole && this.authService.loginUser.managementTeams.length > 0 && this.authService.loginUser.managementTeams[0].id;
        this.userService.getAll().subscribe((users) => {
          this.userNameMap = users.reduce((result, user) => {
            result[user.id] = user.name || '';
            return result;
          }, {});
        });
      }
    });
    this.dynamicFieldSubscription = this.dynamicService.fieldUpdateEvent.subscribe(() => {
      const makeDdFieldDropdownData = (ddField: DynamicField): { label: string; value: string }[] => {
        if (
          !ddField ||
          !ddField.validationStyle ||
          !Array.isArray(ddField.validationStyle.options) ||
          ddField.validationStyle.options.length === 0
        ) {
          throw new Error('ddField is not valid for making list');
        }
        return [
          { label: '-----', value: null },
          ...ddField.validationStyle.options.map((option) => ({ label: option, value: option }))
        ];
      };
      this.yomiDropdownData = makeDdFieldDropdownData(this.dynamicService.getDefinition('progress', 'raYomi'));
      this.expectedContractWeekDropdownData = makeDdFieldDropdownData(
        this.dynamicService.getDefinition('progress', 'raExpectedContractWeek'),
      );
      this.yomi3PassedDropdownData = makeDdFieldDropdownData(
        this.dynamicService.getDefinition('progress', 'raYomi3Passed'),
      );
      this.yomi3InclinationDropdownData = makeDdFieldDropdownData(
        this.dynamicService.getDefinition('progress', 'raYomi3Inclination'),
      );
      this.yomi3ScheduleDropdownData = makeDdFieldDropdownData(
        this.dynamicService.getDefinition('progress', 'raYomi3Schedule'),
      );
    });

    this.updateDisplayForExpectedContractWeekly();

    this.studentsRefreshSubscription = this.studentService.refreshEvent.subscribe(() => {
      // this.handleUpdateFilter();
    });

    this.customerApiRefreshSubscription = this.customerApiService.refreshEvent.subscribe(() => {
      this.handleUpdateFilter();
    });

    this.isHeaderOpenSubscriber = this.managementTableVisibility.gyosekiManagementVisible$.subscribe((value) => {
      this.isHeaderOpen = value;
    });
  }

  ngOnDestroy() {
    if (this.isHeaderOpenSubscriber) {
      this.isHeaderOpenSubscriber.unsubscribe();
      this.isHeaderOpenSubscriber = null;
    }

    if (this.loginSubscription) {
      this.loginSubscription.unsubscribe();
      this.loginSubscription = null;
    }

    if (this.studentsRefreshSubscription) {
      this.studentsRefreshSubscription.unsubscribe();
      this.studentsRefreshSubscription = null;
    }

    if (this.customerApiRefreshSubscription) {
      this.customerApiRefreshSubscription.unsubscribe();
      this.customerApiRefreshSubscription = null;
    }
    if (this.dynamicFieldSubscription) {
      this.dynamicFieldSubscription.unsubscribe();
      this.dynamicFieldSubscription = null;
    }
  }
  updateTableDataWithTeamId(newTeamId: number): void {
    if(newTeamId) {
      this.selectedManagementTeamId = newTeamId;
      this.loadHeaderDataWithTeamSearch({
        teamId: newTeamId
      }, { resetPage: true, withSummary: true });
    } else {
      this.selectedManagementTeamId = null;
      this.loadHeaderDataForCurrentUser(this.authService.loginUser.id, { resetPage: true, withSummary: true });
    }
  }
  handleRaYomi3Change(progress: ProgressItemResponse, yomi3Target: Yomi3Target) {
    this.expectedCompanyYomiService.handleRaYomi3Change({
      progress,
      yomi3Target
    })
    .subscribe(async() => {
      setTimeout(() => {
        this.expectedCompanyYomiService.callCalculateApiForRaYomi3Probability(progress).subscribe((result) => {
          this.customerProgressesRaYomi3ProbabilityResultMapping[progress.id] = result;
        });
      }, 0);
    });
  }

  handlerRaYomiTypeChange(progressId: number, raYomi: YomiType) {
    this.expectedCompanyYomiService.handlerRaYomiTypeChange(progressId, raYomi)
      .subscribe(() => {
        // this.studentService.refreshEvent.emit();
      });
  }

  handleUpdateFilter() {
    if(this.selectedManagementTeamId) {
      this.loadHeaderDataWithTeamSearch({teamId: this.selectedManagementTeamId }, { resetPage: true, withSummary: true });
    } else {
      this.loadHeaderDataForCurrentUser(this.authService.loginUser.id, { resetPage: true, withSummary: true });
    }
  }

  handleRaExpectedSKUpdate(progress: ProgressItemResponse, expectedSk: number) {
    this.expectedCompanyYomiService
      .handleExpectedSKUpdate(
        progress.studentId,
        progress.id,
        expectedSk
      )
      .subscribe((res) => this.customerApiService.refreshEvent.emit());
  }

  getYearMonthFromDateString(dateString) {
    return this.expectedCompanyYomiService.getYearMonthFromDateString(dateString);
  }

  getCustomerFromProgress(progress: ProgressItemResponse) {
    return progress.studentId && this.customers.find(c => c.id === progress.studentId);
  }

  getRaUserFromProgress(progress: ProgressItemResponse) {
    const raProgressUser = (progress.progressUsers || []).find(
      (progressUser) => progressUser.type === ProgressAgentType.RA,
    );
    if (raProgressUser && raProgressUser.userId != null) {
      return this.userTeamInjector.getUserTeamInfoById(raProgressUser.userId);
    }

    return of(null);
  }

  private sortCustomerProgressesByCustomer(compareFn: (a: Student, b: Student) => number): void {
    this.customerProgresses.sort((progressA, progressB) => {
      const customerA = this.getCustomerFromProgress(progressA);
      const customerB = this.getCustomerFromProgress(progressB);

      if (!customerA && !customerB) {
        return 0;
      }
      if (!customerA) {
        return 1;
      }
      if (!customerB) {
        return -1;
      }

      return compareFn(customerA, customerB);
    });
  }

  get customerFilterDefinitions(): CustomerFilterDefinition[] {
    return [
      ...(this.selectedManagementTeamId
        ? [{
            key: 'userName',
            label: 'ユーザー名',
            type: 'select' as const,
            options: this.buildUserNameOptions(),
          }]
        : []),
      {
        key: 'raYomi',
        label: 'ヨミ',
        type: 'select',
        options: this.makeDropdownOptions(this.yomiDropdownData),
      },
      {
        key: 'activeCount',
        label: '稼働',
        type: 'number',
      },
      {
        key: 'progressCount',
        label: '進捗',
        type: 'number',
      },
      {
        key: 'sf',
        label: 'SF',
        type: 'select',
        options: this.buildSelectOptions(
          this.customers
            .map((customer) => customer && customer.dynamicData ? customer.dynamicData.rank : null)
            .filter((value): value is string => !!value)
        ),
      },
      {
        key: 'graduateYear',
        label: '卒業年',
        type: 'select',
        options: this.buildSelectOptions(
          [
            String(new Date().getFullYear()),
            ...this.customers
            .map((customer) => customer && customer.dynamicData && customer.dynamicData.academicHistory1
              ? customer.dynamicData.academicHistory1.graduateYear
              : null)
          ]
            .filter((value): value is string => !!value)
            .filter((value, index, array) => array.indexOf(value) === index)
        ),
      },
      {
        key: 'raYomi3Passed',
        label: '3軸ヨミ(合格)',
        type: 'select',
        options: this.makeDropdownOptions(this.yomi3PassedDropdownData),
      },
      {
        key: 'raYomi3Inclination',
        label: '3軸ヨミ(意向)',
        type: 'select',
        options: this.makeDropdownOptions(this.yomi3InclinationDropdownData),
      },
      {
        key: 'raYomi3Schedule',
        label: '3軸ヨミ(日程)',
        type: 'select',
        options: this.makeDropdownOptions(this.yomi3ScheduleDropdownData),
      },
    ];
  }

  get filteredCustomerProgresses(): ProgressItemResponse[] {
    return this.customerProgresses;
  }

  get pageRangeStart(): number {
    if (this.totalFilteredCount === 0) {
      return 0;
    }

    return (this.currentPage - 1) * this.pageSize + 1;
  }

  get pageRangeEnd(): number {
    return Math.min(this.currentPage * this.pageSize, this.totalFilteredCount);
  }

  get totalPages(): number {
    return Math.ceil(this.totalFilteredCount / this.pageSize);
  }

  get pageNumbers(): (number | string)[] {
    const total = this.totalPages;

    if (total <= 7) {
      return Array.from({ length: total }, (_, index) => index + 1);
    }

    const pages: (number | string)[] = [];
    if (this.currentPage <= 4) {
      for (let i = 1; i <= 5; i++) {
        pages.push(i);
      }
      pages.push('...');
      pages.push(total);
    } else if (this.currentPage >= total - 3) {
      pages.push(1);
      pages.push('...');
      for (let i = total - 4; i <= total; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      pages.push('...');
      pages.push(this.currentPage - 1);
      pages.push(this.currentPage);
      pages.push(this.currentPage + 1);
      pages.push('...');
      pages.push(total);
    }

    return pages;
  }
  getRaYomi3ProbabilityResultFromProgress(progress: ProgressItemResponse): Yomi3ProbabilityCalcResult {
    return (
      this.customerProgressesRaYomi3ProbabilityResultMapping &&
      this.customerProgressesRaYomi3ProbabilityResultMapping[progress.id]
    ) || this.expectedCompanyYomiService.makeRaYomi3ProbabilityDataFrom(progress);
  }

  handleUpdateRaExpectedContractMonth($event, progress: ProgressItemResponse) {
    this.expectedCompanyYomiService
      .handleUpdateRaExpectedContractMonth($event.target.value, progress)
      .subscribe(() => {
        (res) => this.customerApiService.refreshEvent.emit()
      });
  }

  handleUpdateRaExpectedContractWeek(progress: ProgressItemResponse) {
    this.customerApiService.updateRaExpectedContractWeek(
      progress.id,
      progress.dynamicData.raExpectedContractWeek
    ).subscribe(
      (res) => this.customerApiService.refreshEvent.emit()
    );
  }

  handleShowRaExpectedSKInfoDialog(progress: ProgressItemResponse) {
    // progress => job_id を取得
    // job => enterprise_department => enterprise => contracts を取得
    this.companyApiService.getContractsRelatedToJob(
      progress.jobId
    ).subscribe((contracts: Contract[]) => {
      this.dialog.open(
        GyosekiManagementCustomerProgressSkInfoDialogComponent,
        {
          data: { contracts },
        }
      );
    });
  }

  handleSaveRaMemo(progressId:number, memoString: string) {
    this.expectedCompanyYomiService.handleSaveRaMemo(progressId, memoString)
      .subscribe(() => {
        this.customerApiService.refreshEvent.emit();
      });
  }
  handleChangeExpectedCompany(studentId: number, newExpectedCompany: number): void {
    this.expectedCompanyYomiService.updateCustomerExpectedCompany(
      studentId,
      newExpectedCompany,
      this.customersExpectedCompanyListMapping
    ).subscribe((responseStatus: ResponseStatus) => {
        if (responseStatus.status) {
          const expectedData = this.customersExpectedCompanyListMapping[studentId].find(
            ec => ec.p_id === Number(newExpectedCompany)
          );

          this.updateExpectedCompanyMappings(ExpectedCompanyTarget.Company1, studentId, expectedData);
        }
      });
  }

  handleChangeExpectedCompany2(studentId: number, newExpectedCompany: number): void {
    this.expectedCompanyYomiService.updateCustomerExpectedCompany2(
      studentId,
      newExpectedCompany,
      this.customersExpectedCompanyListMapping
    ).subscribe((responseStatus: ResponseStatus) => {
        if (responseStatus.status) {
          const expectedData = this.customersExpectedCompanyListMapping[studentId].find(
            ec => ec.p_id === Number(newExpectedCompany)
          );

          this.updateExpectedCompanyMappings(ExpectedCompanyTarget.Company2, studentId, expectedData);
        }
      });
  }

  updateExpectedCompanyMappings(target: ExpectedCompanyTarget | string, studentId: number, expectedData: ExpectedCompanyResponseDto | null) {
    if(target === ExpectedCompanyTarget.Company1) {
      if (expectedData) {
        expectedData.yomi3ProbabilityCalcResult = this.expectedCompanyYomiService.makeYomi3ProbabilityDataFrom(expectedData);
        this.customersExpectedCompanyProgressIdMapping[studentId] = expectedData.p_id;
        this.customersExpectedCompanyMapping[studentId] = expectedData;
      } else {
        this.customersExpectedCompanyProgressIdMapping[studentId] = 0;
        this.customersExpectedCompanyMapping[studentId] = {};
      }
    } else if (target === ExpectedCompanyTarget.Company2) {
      if (expectedData) {
        this.customersExpectedCompany2ProgressIdMapping[studentId] = expectedData.p_id;
        this.customersExpectedCompany2Mapping[studentId] = expectedData;
      } else {
        this.customersExpectedCompany2ProgressIdMapping[studentId] = 0;
        this.customersExpectedCompany2Mapping[studentId] = {};
      }
    }
  }

  updateDisplayForExpectedContractWeekly() {
    const currentWeekKey = `w${this.expectedCompanyYomiService.currentWeekTarget()}`;
    const currentWeeklyData = this.expectedCompanyYomiService.isCurrentMonth5WeekTarget() ? this.weekTarget5w[currentWeekKey] : this.weekTarget4w[currentWeekKey];

    this.expectedContractWeeklyValue = Object.entries(currentWeeklyData)
      .map(([key, value]) => `${key}: ${value}`)
      .join(' | ');
  }

  processCustomerProgressListResponse(customerProgressList: CustomerProgressList) {
    this.customerProgresses = this.expectedCompanyYomiService.getDefaultSortedCustomerProgressess(customerProgressList.progresses);
    this.customerProgressesRaYomi3ProbabilityResultMapping = {};
    this.customerProgresses.forEach(progress => {
      this.customerProgressesRaYomi3ProbabilityResultMapping[progress.id] =
        this.expectedCompanyYomiService.makeRaYomi3ProbabilityDataFrom(progress);
    });
    // customers 内部の重複を許す（全ての進捗を表示）
    this.customers = customerProgressList.students;
    this.customerTotal = customerProgressList.progresses.length;

    this.customersExpectedCompanyListMapping = customerProgressList.expectedCompanies;
    this.customersExpectedCompanyUIList = {};
    this.customersExpectedCompanyProgressIdMapping = {};
    this.customersExpectedCompanyMapping = {};
    this.customersExpectedCompany2ProgressIdMapping = {};
    this.customersExpectedCompany2Mapping = {};
    this.pickUpMemo = {};
    Object.keys(this.customersExpectedCompanyListMapping).forEach(studentId => {
      this.customersExpectedCompanyUIList[studentId] = 
        this.expectedCompanyYomiService.makeCustomersExpectedCompanyUIList(
          this.customersExpectedCompanyListMapping[studentId]
        );

      // Update Expected Company 1 & 2 Mappings
      for (const targetKey in ExpectedCompanyTarget) {
        // console.log(targetKey);
        const expectedCompanyTarget = ExpectedCompanyTarget[targetKey];
        const foundExpectedCompany: ExpectedCompanyResponseDto = this.customersExpectedCompanyListMapping[studentId].find(
          expectedCompany => Number(expectedCompany[expectedCompanyTarget]) === 1
        );
        this.updateExpectedCompanyMappings(expectedCompanyTarget, Number(studentId), foundExpectedCompany);
      }

      // Memo Logic
      const customer = this.customers.find((cus) => cus.id === Number(studentId));
      this.pickUpMemo[studentId] = this.expectedCompanyYomiService
        .pickTop1StudentSituationMemoWithSortAndFormat(
          customer.studentSituationMemo
        );
    });
  }

  processSalesReportResponse(salesAmountForUser: SalesAmountForUser) {
    if(salesAmountForUser && salesAmountForUser.rapa) {
      this.salesForUserModel = salesAmountForUser;
    } else {
      this.salesForUserModel = this.defaultSalesForUserModel;
    }
  }

  processSalesSummaryForUser(salesAmountForUser: SalesAmountForUser, monthlySalesOverview: MonthlySalesOverview) {
    this.salesSummaryForUserModel = this.expectedCompanyYomiService.doCalculateSalesSummaryForUser(
      salesAmountForUser,
      monthlySalesOverview
    );
  }

  processTeamSalesReportResponse(salesAmount: SalesAmount) {
    if(salesAmount && salesAmount.rapa) {
      this.salesForTeamModel = salesAmount;
    } else {
      this.salesForTeamModel = this.defaultSalesForTeamModel;
    }
  }
  processTeamSalesSummary(salesAmount: SalesAmount, teamMonthlySalesOverviews: TeamMonthlySalesOverviews ) {
    if((salesAmount && salesAmount.rapa) || teamMonthlySalesOverviews) {
      this.salesSummaryForTeamModel = this.expectedCompanyYomiService.doCalculateSalesSummaryForTeam(
        salesAmount,
        teamMonthlySalesOverviews,
      );
    } else {
      this.salesSummaryForTeamModel = this.defaultSalesSummaryForTeamModel;
    }
  }

  private loadCurrentUserCustomerTotal(): void {
    const filterParams = this.buildFilterParams();
    this.expectedCompanyYomiService
      .fetchMyRaSalesTargetCustomerTotal(
        this.selectedExpectedContractMonthValue,
        filterParams,
      )
      .subscribe({
        next: (response) => {
          this.totalFilteredCount = response.total || 0;
        },
        error: () => {
          this.totalFilteredCount = 0;
        },
      });
  }

  private loadTeamCustomerTotal(teamId: number): void {
    const filterParams = this.buildFilterParams();
    this.expectedCompanyYomiService
      .fetchTeamRaSalesTargetCustomerTotal(
        teamId,
        this.selectedExpectedContractMonthValue,
        filterParams,
      )
      .subscribe({
        next: (response) => {
          this.totalFilteredCount = response.total || 0;
        },
        error: () => {
          this.totalFilteredCount = 0;
        },
      });
  }

  private loadCurrentUserCustomerList(): void {
    this.loadingCustomer = true;
    const filterParams = this.buildFilterParams();

    this.expectedCompanyYomiService
      .fetchMyRaSalesTargetCustomerList(
        this.selectedExpectedContractMonthValue,
        this.currentPage,
        this.pageSize,
        filterParams,
      )
      .subscribe({
        next: (customerProgressList: CustomerProgressList) => {
          this.processCustomerProgressListResponse(customerProgressList);
        },
        error: () => {
          this.loadingCustomer = false;
        },
        complete: () => {
          this.loadingCustomer = false;
        }
      });
  }

  private loadTeamCustomerList(teamId: number): void {
    this.loadingCustomer = true;
    const filterParams = this.buildFilterParams();

    this.expectedCompanyYomiService
      .fetchTeamRaSalesTargetCustomerList(
        teamId,
        this.selectedExpectedContractMonthValue,
        this.currentPage,
        this.pageSize,
        filterParams,
      )
      .subscribe({
        next: (customerProgressList: CustomerProgressList) => {
          this.processCustomerProgressListResponse(customerProgressList);
        },
        error: () => {
          this.loadingCustomer = false;
        },
        complete: () => {
          this.loadingCustomer = false;
        }
      });
  }

  private loadCurrentPage(): void {
    if (this.selectedManagementTeamId) {
      this.loadTeamCustomerList(this.selectedManagementTeamId);
      return;
    }

    this.loadCurrentUserCustomerList();
  }

  loadHeaderDataForCurrentUser(userId, options: { resetPage?: boolean; withSummary?: boolean } = {}) {
    const { resetPage = false, withSummary = true } = options;

    if (resetPage) {
      this.currentPage = 1;
    }

    if (withSummary) {
      this.totalFilteredCount = 0;
      forkJoin([
          this.expectedCompanyYomiService.fetchMySalesReport(this.selectedExpectedContractMonthValue),
          this.expectedCompanyYomiService.fetchMyMonthlySalesOverview(this.selectedExpectedContractMonthValue),
        ]).subscribe({
          next: ([salesAmountForUser, monthlySalesOverview]: [SalesAmountForUser, MonthlySalesOverview]) => {
            this.processSalesReportResponse(salesAmountForUser);
            this.processSalesSummaryForUser(
              salesAmountForUser,
              monthlySalesOverview
            );
          },
        });

      this.loadCurrentUserCustomerTotal();
    }

    this.loadCurrentUserCustomerList();
  }

  loadHeaderDataWithTeamSearch({ teamId }: { teamId: number }, options: { resetPage?: boolean; withSummary?: boolean } = {}) {
    const { resetPage = false, withSummary = true } = options;

    if (resetPage) {
      this.currentPage = 1;
    }

    if (withSummary) {
      this.totalFilteredCount = 0;
      forkJoin([
          this.expectedCompanyYomiService.fetchTeamSalesReport(teamId, this.selectedExpectedContractMonthValue),
          this.expectedCompanyYomiService.fetchTeamMonthlySalesOverviews(teamId, this.selectedExpectedContractMonthValue),
        ]).subscribe({
          next: ([salesAmount, teamMonthlySalesOverviews]: [SalesAmount, TeamMonthlySalesOverviews]) => {
            this.processTeamSalesReportResponse(salesAmount);
            this.processTeamSalesSummary(salesAmount, teamMonthlySalesOverviews);
          },
        });

      this.loadTeamCustomerTotal(teamId);
    }

    this.loadTeamCustomerList(teamId);
  }

  toggleGlobalGyosekiManagementHeader(): void {
    this.managementTableVisibility.toggleGlobalGyosekiManagementHeader();

    if (this.isHeaderOpen) {
      this.customerFilterConditions = [];
      this.handleUpdateFilter();
    }
  }

  openChat(lineId): void {
    return this.expectedCompanyYomiService.openChat(lineId);
  }

  handlerGraduateYearView(year): string {
    return this.expectedCompanyYomiService.handlerGraduateYearView(year);
  }

  handlerDateMonthDayPlusjp(dateData) {
    return this.expectedCompanyYomiService.handlerDateMonthDayPlusjp(dateData);
  }

  onItemSelect(selectedItem: any): void {
    openStudentDetail(selectedItem);
  }

  onItemSelectAndMemo(selectedItem: any): void {
    openStudentDetailMemo(selectedItem);
  }

  openMailSend(config: MailSendConfig = this.detailConfig, student): void {
    openStudentMailSend(config, student);
  }

  handlerExpectedCompanyTypeView(type: number): string {
    return this.expectedCompanyYomiService.handlerExpectedCompanyTypeView(type);
  }

  handlerProgressStatusView(expectedCompany: ExpectedCompanyResponseDto): string {
    return this.expectedCompanyYomiService.handlerProgressStatusView(expectedCompany, PROGRESS_STATUSES);
  }

  getProgressStatusViewFromProgress(progress: ProgressItemResponse): string {
    return this.expectedCompanyYomiService.getProgressStatusViewFromProgress(
      progress,
      PROGRESS_STATUSES
    );
  }
  getEnterpriseNameFromProgress(progress: ProgressItemResponse): string {
    return this.expectedCompanyYomiService.getEnterpriseNameFromProgress(progress);
  }

  handleOpenEnterpriseDetail(progress: ProgressItemResponse): void {
    openEnterpriseDetail(progress);
  }
  handleOpenEnterpriseDetailWithId(id: number): void {
    openEnterpriseDetailWithId(id);
  }

  handleCustomerFilterChange(conditions: CustomerFilterCondition[]): void {
    this.customerFilterConditions = conditions;
    this.handleUpdateFilter();
  }

  goToPage(page: number): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }

    this.currentPage = page;
    this.loadCurrentPage();
  }

  handlerUserNameSort() {
    if (this.userNameSortStatus === 'asc') {
      this.userNameSortStatus = 'desc';
      this.customerProgresses.sort((a, b) => this.compareUserNameOrder(a, b));
      return;
    }

    this.userNameSortStatus = 'asc';
    this.customerProgresses.sort((a, b) => this.compareUserNameOrder(b, a));
  }

  handlerYomiSort() {
    if (this.yomiSortStatus === 'asc') {
      this.yomiSortStatus = 'desc';
      this.customerProgresses.sort((a, b) =>
        this.compareYomiOrder(
          a && a.dynamicData ? a.dynamicData.raYomi : undefined,
          b && b.dynamicData ? b.dynamicData.raYomi : undefined
        )
      );
      return;
    }

    this.yomiSortStatus = 'asc';
    this.customerProgresses.sort((a, b) =>
        this.compareYomiOrder(
          b && b.dynamicData ? b.dynamicData.raYomi : undefined,
          a && a.dynamicData ? a.dynamicData.raYomi : undefined
        )
      );
  }

  handlerActiveSort() {
    if (this.activeSortStatus === 'asc') {
      this.activeSortStatus = 'desc';

      this.sortCustomerProgressesByCustomer((a, b) => {
        if (!b.activeCount || a.activeCount > b.activeCount) {
          return -1;
        }
        if (a.activeCount < b.activeCount) {
          return 1;
        }
        return 0;
      });
      return;
    }

    this.activeSortStatus = 'asc';
    this.sortCustomerProgressesByCustomer((a, b) => {
      if (!a.activeCount || a.activeCount < b.activeCount) {
        return -1;
      }
      if (a.activeCount > b.activeCount) {
        return 1;
      }
      return 0;
    });
  }

  handlerProgressSort() {
    if (this.progressSortStatus === 'asc') {
      this.progressSortStatus = 'desc';

      this.sortCustomerProgressesByCustomer((a, b) => {
        if (!b.progressCount || a.progressCount > b.progressCount) {
          return -1;
        }
        if (a.progressCount < b.progressCount) {
          return 1;
        }
        return 0;
      });
      return;
    }

    this.progressSortStatus = 'asc';
    this.sortCustomerProgressesByCustomer((a, b) => {
      if (!a.progressCount || a.progressCount < b.progressCount) {
        return -1;
      }
      if (a.progressCount > b.progressCount) {
        return 1;
      }
      return 0;
    });
  }

  handlerGraduateYearSort() {
    if (this.graduateYearSortStatus === 'asc') {
      this.graduateYearSortStatus = 'desc';

      this.sortCustomerProgressesByCustomer((a, b) => {
        if (
          !b.dynamicData.academicHistory1.graduateYear ||
          a.dynamicData.academicHistory1.graduateYear > b.dynamicData.academicHistory1.graduateYear
        ) {
          return -1;
        }
        if (a.dynamicData.academicHistory1.graduateYear < b.dynamicData.academicHistory1.graduateYear) {
          return 1;
        }
        return 0;
      });
      return;
    }

    this.graduateYearSortStatus = 'asc';
    this.sortCustomerProgressesByCustomer((a, b) => {
      if (
        !a.dynamicData.academicHistory1.graduateYear ||
        a.dynamicData.academicHistory1.graduateYear < b.dynamicData.academicHistory1.graduateYear
      ) {
        return -1;
      }
      if (a.dynamicData.academicHistory1.graduateYear > b.dynamicData.academicHistory1.graduateYear) {
        return 1;
      }
      return 0;
    });
  }

  handlerYomi3Sort(yomi3Key: Yomi3Target) {
    const yomi3SortDataMapping = {
      [Yomi3Target.passed]: {
        sortStatusRefKey: 'yomi3PassedSortStatus',
        dropdownDataListRefKey: 'yomi3PassedDropdownData',
        sortValueKey: 'p_yomi_3_passed'
      },
      [Yomi3Target.inclination]: {
        sortStatusRefKey: 'yomi3InclinationSortStatus',
        dropdownDataListRefKey: 'yomi3InclinationDropdownData',
        sortValueKey: 'p_yomi_3_inclination'
      },
      [Yomi3Target.schedule]: {
        sortStatusRefKey: 'yomi3ScheduleSortStatus',
        dropdownDataListRefKey: 'yomi3ScheduleDropdownData',
        sortValueKey: 'p_yomi_3_schedule'
      }
    };
    const sortData = yomi3SortDataMapping[yomi3Key];
    if(!sortData) {
      throw new Error(`${yomi3Key} sort not defined`);
    }
    const {
      sortStatusRefKey,
      dropdownDataListRefKey,
      sortValueKey
    } = sortData;

    const dropdownDataListRef = this[dropdownDataListRefKey];

    if (this[sortStatusRefKey] === 'asc') {
      this[sortStatusRefKey] = 'desc';

      this.sortCustomerProgressesByCustomer((a, b) => {
        const companyProgressDataForA = this.customersExpectedCompanyMapping[a.id];
        const companyProgressDataForB = this.customersExpectedCompanyMapping[b.id];

        // companyProgressData の dynamicData.yomi3Passed の値 が this.yomi3PassedDropdownData の要素 :{value: string} の value と一致する index が小さい順にソートする
        const getIndex = (v) => {
          const i = dropdownDataListRef.filter(t => t.value).findIndex(t => t && t.value === v);
          return i === -1 ? Number.POSITIVE_INFINITY : i;
        };
        const idxA = getIndex(companyProgressDataForA[sortValueKey]);
        const idxB = getIndex(companyProgressDataForB[sortValueKey]);
        return idxA - idxB;
      });
    } else {
      this[sortStatusRefKey] = 'asc';
      this.sortCustomerProgressesByCustomer((a, b) => {
        const companyProgressDataForA = this.customersExpectedCompanyMapping[a.id];
        const companyProgressDataForB = this.customersExpectedCompanyMapping[b.id];
        // companyProgressData の dynamicData.yomi3Passed の値 が this.yomi3PassedDropdownData の要素 :{value: string} の value と一致する index が大きい順にソートする
        const getIndex = (v) => {
          const i = dropdownDataListRef.filter(t => t.value).findIndex(t => t && t.value === v);
          return i === -1 ? Number.POSITIVE_INFINITY : i;
        };
        const idxA = getIndex(companyProgressDataForA[sortValueKey]);
        const idxB = getIndex(companyProgressDataForB[sortValueKey]);
        return idxB - idxA;
      });
    }
  }

  handlerSfSort() {
    if (this.sfSortStatus === 'asc') {
      this.sfSortStatus = 'desc';

      this.sortCustomerProgressesByCustomer((a, b) => {
        if (!b.dynamicData.rank || a.dynamicData.rank > b.dynamicData.rank) {
          return -1;
        }
        if (a.dynamicData.rank < b.dynamicData.rank) {
          return 1;
        }
        return 0;
      });
      return;
    }

    this.sfSortStatus = 'asc';
    this.sortCustomerProgressesByCustomer((a, b) => {
      if (!a.dynamicData.rank || a.dynamicData.rank < b.dynamicData.rank) {
        return -1;
      }
      if (a.dynamicData.rank > b.dynamicData.rank) {
        return 1;
      }
      return 0;
    });
  }

  handlerPickUpMemoRegisterSort() {
    if (this.pickUpMemoRegisterSortStatus === 'asc') {
      this.pickUpMemoRegisterSortStatus = 'desc';

      this.sortCustomerProgressesByCustomer((a, b) => {
        const aPick = this.pickUpMemo[a.id];
        const bPick = this.pickUpMemo[b.id];
        // console.log('aPick', aPick);
        // console.log('bPick', bPick);

        if (!aPick && !bPick) {
          return 0;
        }
        if (aPick === bPick) {
          return 0;
        }
        if (!bPick || !bPick.registerDate || (aPick && aPick.registerDate > bPick.registerDate)) {
          return -1;
        }
        return 1;
      });
      return;
    }

    this.pickUpMemoRegisterSortStatus = 'asc';
    this.sortCustomerProgressesByCustomer((a, b) => {
      const aPick = this.pickUpMemo[a.id];
      const bPick = this.pickUpMemo[b.id];

      if (!aPick && !bPick) {
        return 0;
      }
      if (aPick === bPick) {
        return 0;
      }
      if (!aPick || !aPick.registerDate || (bPick && aPick.registerDate < bPick.registerDate)) {
        return -1;
      }
      return 1;
    });
  }

  handleSaveMyMonthlySalesOverviewForTargetMonth() {
    this.expectedCompanyYomiService.handleSaveMyMonthlySalesOverviewForTargetMonth(
      this.selectedExpectedContractMonthValue,
      this.salesSummaryForUserModel,
      'rapa',
    ).subscribe(() => {
      // 
    });
  }

  private makeDropdownOptions(data: Array<{ label: string; value: string | null }>): CustomerFilterOption[] {
    return (data || [])
      .filter((item): item is { label: string; value: string } => !!item.value)
      .map((item) => ({
        label: item.label,
        value: item.value,
      }));
  }

  private buildSelectOptions(values: string[]): CustomerFilterOption[] {
    return Array.from(new Set(values)).map((value) => ({
      label: value,
      value,
    }));
  }

  private buildUserNameOptions(): CustomerFilterOption[] {
    const options: Array<{ label: string; value: number }> = this.customerProgresses
      .map((progress) => {
        const raProgressUser = (progress && progress.progressUsers || []).find(
          (progressUser) => progressUser.type === ProgressAgentType.RA,
        );
        if (!raProgressUser || !raProgressUser.userId) {
          return null;
        }

        return {
          label: this.getRaUserName(progress),
          value: raProgressUser.userId,
        };
      })
      .filter((option): option is { label: string; value: number } => !!option && !!option.label);

    return options.filter(
      (option, index, array) => array.findIndex((item) => item.value === option.value) === index,
    );
  }

  private buildFilterParams(): Record<string, string | number | Array<string | number>> {
    return this.customerFilterConditions.reduce((params, condition) => {
      switch (condition.key) {
        case 'userName':
          params.progressRaOrPaUserId = [Number(condition.value)];
          break;
        case 'activeCount':
          params.activeCount = Number(condition.value);
          break;
        case 'progressCount':
          params.progressCount = Number(condition.value);
          break;
        case 'raYomi':
          params.raYomi = String(condition.value);
          break;
        case 'sf':
          params.rank = [String(condition.value)];
          break;
        case 'graduateYear':
          params.graduateYear = String(condition.value);
          break;
        case 'raYomi3Passed':
          params.raYomi3Passed = String(condition.value);
          break;
        case 'raYomi3Inclination':
          params.raYomi3Inclination = String(condition.value);
          break;
        case 'raYomi3Schedule':
          params.raYomi3Schedule = String(condition.value);
          break;
        default:
          break;
      }

      return params;
    }, {} as Record<string, string | number | Array<string | number>>);
  }

  private matchesCustomerFilterCondition(progress: ProgressItemResponse, condition: CustomerFilterCondition): boolean {
    const customer = this.getCustomerFromProgress(progress);
    const raProgressUser = (progress && progress.progressUsers || []).find(
      (progressUser) => progressUser.type === ProgressAgentType.RA,
    );
    const valueMap: Record<string, string | number | unknown[] | undefined> = {
      userName: raProgressUser ? raProgressUser.userId : undefined,
      activeCount: customer ? customer.activeCount : undefined,
      progressCount: customer ? customer.progressCount : undefined,
      raYomi: progress && progress.dynamicData ? progress.dynamicData.raYomi : undefined,
      sf: customer && customer.dynamicData ? customer.dynamicData.rank : undefined,
      graduateYear: customer && customer.dynamicData && customer.dynamicData.academicHistory1
        ? customer.dynamicData.academicHistory1.graduateYear
        : undefined,
      raYomi3Passed: progress && progress.dynamicData ? progress.dynamicData.raYomi3Passed : undefined,
      raYomi3Inclination: progress && progress.dynamicData ? progress.dynamicData.raYomi3Inclination : undefined,
      raYomi3Schedule: progress && progress.dynamicData ? progress.dynamicData.raYomi3Schedule : undefined,
    };
    const currentValue = valueMap[condition.key];

    if (currentValue === null || currentValue === undefined || condition.value === null || condition.value === undefined) {
      return false;
    }

    if (typeof currentValue === 'number') {
      return currentValue === Number(condition.value);
    }

    return String(currentValue) === String(condition.value);
  }

  private compareUserNameOrder(a: ProgressItemResponse, b: ProgressItemResponse): number {
    const aUserName = this.getRaUserName(a);
    const bUserName = this.getRaUserName(b);
    return aUserName.localeCompare(bUserName, 'ja');
  }

  private getRaUserName(progress: ProgressItemResponse): string {
    const raProgressUser = (progress && progress.progressUsers || []).find(
      (progressUser) => progressUser.type === ProgressAgentType.RA,
    );
    if (!raProgressUser) {
      return '';
    }
    if (raProgressUser.user && raProgressUser.user.name) {
      return raProgressUser.user.name;
    }
    return this.userNameMap[raProgressUser.userId] || '';
  }

  private compareYomiOrder(aYomi?: string, bYomi?: string): number {
    const yomiOrder = [
      'マイナスカタ',
      'マイナスFCST',
      'マイナス★',
      'マイナスノビ',
      'カタ',
      'FCST',
      '★',
      'ノビ',
    ];
    const getIndex = (value?: string) => {
      const index = yomiOrder.indexOf(value || '');
      return index === -1 ? Number.POSITIVE_INFINITY : index;
    };
    const aIndex = getIndex(aYomi);
    const bIndex = getIndex(bYomi);

    if (aIndex < bIndex) {
      return -1;
    }
    if (aIndex > bIndex) {
      return 1;
    }
    return 0;
  }
  
}
